import cryptoRandomString from "crypto-random-string";
import { getAdjustedPrice, logger } from "../utilities";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import customerService from "../api/customerService";
import CustomerService from "../api/customerService";
import accountOfferingsService from "../api/accountOfferingsService";
import { generateRelations } from "../helpers/offeringRelations";

const LOG_PREFIX = "[Store.js]";
export const useAppStore = create(
  persist(
    (set, get) => ({
      COMPANY: {},
      USER: {},
      CLIENT: {},
      CART: {
        total: 0,
        count: 0,
        accepted: [],
        declined: [],
        quantity: {},
        paid: [], // array of ids which will dictate which to be put where when loading previous
        previously_accepted: {}, // offerings: [], quantity: [], total: 0
        previously_purchased: {}, // offerings: [], quantity: [], total: 0
      },
      SALE: {},
      OFFERINGS: [],
      RELATIONS: null,
      OFFLINE: false,
      PREVIOUS_CLIENT: {},

      setUSER: (newValue) => {
        if (newValue.email) {
          get()
            .fetchCOMPANY()
            .then((company) => {
              get().fetchOFFERINGS();
              set({ USER: newValue });
            });
        } else {
          get().clearUSER();
        }
      },
      setCLIENT: (client) => {
        const OFFERINGS = get().OFFERINGS;
        const COMPANY = get().COMPANY;
        const CART = get().CART;
        const rectifyCART = get().rectifyCART;
        const setRELATIONS = get().setRELATIONS;
        const fetchOFFERINGS = get().fetchOFFERINGS;
        const previousClient = get().CLIENT;

        logger.debug(LOG_PREFIX, "clientChanged listener", {
          client,
          previousClient,
        });

        // Check if the account has changed
        const accountChanged =
          !previousClient || previousClient.account !== client.account;

        if (accountChanged && client && client.account) {
          console.log(
            `${LOG_PREFIX} setCLIENT - account changed, re-fetching offerings`,
            {
              previousAccount: previousClient?.account,
              newAccount: client.account,
            }
          );

          // Set the client first so fetchOFFERINGS can use the new account
          set({ CLIENT: client });

          // Re-fetch offerings with the new account data
          fetchOFFERINGS()
            .then(() => {
              logger.debug(
                LOG_PREFIX,
                "setCLIENT - offerings refreshed after account change"
              );

              // Continue with the existing logic using fresh offerings
              const freshOfferings = get().OFFERINGS;
              if (
                freshOfferings &&
                freshOfferings.length > 0 &&
                COMPANY &&
                COMPANY.settings
              ) {
                let list = [...new Set(freshOfferings)];
                const accountName = client.account;
                const accounts = COMPANY.settings.json_data.accounts;
                if (accountName && accounts) {
                  logger.debug(LOG_PREFIX, "clientChanged listener", {
                    accountName,
                    accounts,
                  });
                  const removedOfferingIds =
                    accounts[accountName].removedOfferingIds || [];
                  logger.debug(LOG_PREFIX, "clientChanged listener", {
                    accountName,
                    accounts,
                    removedOfferingIds,
                  });
                  list = list.filter((o) => !removedOfferingIds.includes(o.id));
                  logger.debug(LOG_PREFIX, "clientChanged listener", { list });
                }
                const relations = generateRelations(list);
                console.log({ relations });
                setRELATIONS(relations);
                let cartClone = JSON.parse(JSON.stringify(CART));
                rectifyCART(cartClone);
              }
            })
            .catch((error) => {
              console.error(
                `${LOG_PREFIX} setCLIENT - failed to refresh offerings after account change`,
                {
                  error: error.message,
                }
              );
            });
        } else {
          // No account change, proceed with existing logic
          if (
            OFFERINGS &&
            OFFERINGS.length > 0 &&
            COMPANY &&
            COMPANY.settings &&
            client &&
            client.account
          ) {
            logger.debug(LOG_PREFIX, "clientChanged listener", {
              message: "offerings, company, client present",
            });
            let list = [...new Set(OFFERINGS)];
            const accountName = client.account;
            const accounts = COMPANY.settings.json_data.accounts;
            if (accountName && accounts) {
              logger.debug(LOG_PREFIX, "clientChanged listener", {
                accountName,
                accounts,
              });
              const removedOfferingIds =
                accounts[accountName].removedOfferingIds || [];
              logger.debug(LOG_PREFIX, "clientChanged listener", {
                accountName,
                accounts,
                removedOfferingIds,
              });
              list = list.filter((o) => !removedOfferingIds.includes(o.id));
              logger.debug(LOG_PREFIX, "clientChanged listener", { list });
            }
            const relations = generateRelations(list);
            console.log({ relations });
            setRELATIONS(relations);
            let cartClone = JSON.parse(JSON.stringify(CART));
            rectifyCART(cartClone);
          }
          set({ CLIENT: client });
        }
      },
      setRELATIONS: (newValue) => set({ RELATIONS: newValue }),
      setCART: (newValue) => set({ CART: newValue }),
      // setSALE: (newValue) => set({SALE: newValue}),
      setOFFLINE: (newValue) => set({ OFFLINE: newValue }),
      setPREVIOUS_CLIENT: (newValue) => set({ PREVIOUS_CLIENT: newValue }),
      setCOMPANY: async (company) => {
        console.log("setting company", company);
        if (company && company.settings && company.settings.json_data) {
          if (
            company.settings.json_data &&
            company.settings.json_data["accounts"] &&
            Object.keys(company.settings.json_data["accounts"]).length !== 0
          ) {
            logger.debug(LOG_PREFIX, "companyChanged listener", {
              message: "Accounts Present",
            });
            set({ COMPANY: company });
          } else {
            company.settings.json_data = {};
            logger.debug(LOG_PREFIX, "companyChanged listener", {
              message: "Accounts Missing...",
            });
            company.settings.json_data = {
              accounts: Object.assign(company.settings.json_data, {
                "Default Account": { types: ["Default"] },
              }),
            };
            logger.debug(LOG_PREFIX, ".companyChanged listener", {
              company_data: company.settings.json_data,
              message: "Saving Company",
            });
            if (!get().OFFLINE) {
              const newCompany = await CustomerService.updateCustomerSettings(
                company.settings.customer_id,
                company.settings
              );
              set({ COMPANY: newCompany });
            } else {
              set({ COMPANY: company });
            }
          }
        } else {
          throw new Error("Company is not defined");
          get().clearUSER();
        }
      },
      fetchCOMPANY: async () => {
        const company = await customerService.getCustomer();
        company.settings = await customerService.getCustomerSettings(
          company.customerId
        );
        get().setCOMPANY(company);
        return company;
      },
      fetchOFFERINGS: async () => {
        console.log(
          `${LOG_PREFIX} fetchOFFERINGS - starting dual system fetch`
        );

        // First, get offerings from legacy system
        let offerings = await customerService.getOfferings(
          get().COMPANY.customerId
        );
        console.log(`${LOG_PREFIX} fetchOFFERINGS - got legacy offerings`, {
          offeringsCount: offerings.length,
          customerId: get().COMPANY.customerId,
        });

        // If we have a current client with an account, enhance with new table data
        const currentClient = get().CLIENT;
        if (currentClient && currentClient.account) {
          console.log(
            `${LOG_PREFIX} fetchOFFERINGS - enhancing with new table data`,
            {
              accountName: currentClient.account,
              customerId: get().COMPANY.customerId,
            }
          );

          try {
            // Get enhanced offerings that merge new table data with legacy data
            offerings = await accountOfferingsService.getEnhancedOfferingsData(
              get().COMPANY.customerId,
              currentClient.account,
              offerings
            );

            console.log(
              `${LOG_PREFIX} fetchOFFERINGS - successfully enhanced offerings with new table data`
            );
          } catch (error) {
            console.warn(
              `${LOG_PREFIX} fetchOFFERINGS - failed to enhance with new table data, using legacy only`,
              {
                error: error.message,
              }
            );
            // Continue with legacy offerings only
          }
        } else {
          console.log(
            `${LOG_PREFIX} fetchOFFERINGS - no client account set, using legacy data only`
          );
        }

        set({ OFFERINGS: offerings });
        console.log(`${LOG_PREFIX} fetchOFFERINGS - completed`, {
          finalOfferingsCount: offerings.length,
        });
      },
      rectifyCART: (cart) => {
        cart.declined = [];
        cart.accepted = [];
        cart.total = 0;
        cart.count = 0;

        let list = [...new Set(get().OFFERINGS)];
        const accountName = get().CLIENT.account;
        const accounts = get().COMPANY.settings.json_data.accounts;
        if (accountName && accounts) {
          logger.debug(LOG_PREFIX, "clientChanged listener", {
            accountName,
            accounts,
          });
          const removedOfferingIds =
            accounts[accountName].removedOfferingIds || [];
          logger.debug(LOG_PREFIX, "clientChanged listener", {
            accountName,
            accounts,
            removedOfferingIds,
          });
          list = list.filter((o) => !removedOfferingIds.includes(o.id));
          logger.debug(LOG_PREFIX, "clientChanged listener", { list });
        }
        list.forEach((o) => {
          if (!cart.quantity[o.id] || cart.quantity[o.id] === 0) {
            cart.declined.push({
              id: o.id,
              price: getAdjustedPrice(o, get().CLIENT, get().COMPANY),
            });
          } else {
            cart.count = cart.count + parseInt(cart.quantity[o.id]);
            cart.accepted.push({
              id: o.id,
              price: getAdjustedPrice(o, get().CLIENT, get().COMPANY),
            });
          }
        });
        cart.accepted.forEach((o) => {
          cart.total =
            cart.total +
            getAdjustedPrice(o, get().CLIENT, get().COMPANY) *
              cart.quantity[o.id];
        });
        for (let q in cart.quantity) {
          if (cart.quantity[q] < 1) {
            delete cart.quantity[q];
          }
        }
        get().setCART(cart);
      },
      // resetCOMPANY: () => set({COMPANY: {}}),
      // resetUSER: () => set({USER: {}}),
      resetCLIENT: () => set({ CLIENT: {} }),
      resetCART: () =>
        set({
          CART: {
            total: 0,
            count: 0,
            accepted: [],
            declined: [],
            quantity: {},
            paid: [], // array of ids which will dictate which to be put where when loading previous
            previously_accepted: {}, // offerings: [], quantity: [], total: 0
            previously_purchased: {}, // offerings: [], quantity: [], total: 0
          },
        }),
      // resetSALE: () => set({SALE: {}}),
      // resetOFFERINGS: () => set({OFFERINGS: {}}),
      // resetOFFLINE: () => set({OFFLINE: {}}),
      clearPREVIOUS_CLIENT: () => set({ PREVIOUS_CLIENT: {} }),
      clearUSER: () => {
        get().deleteSTORE();
      },
      cleanSTORE: () => {
        get().resetCART();
        get().resetCLIENT();
      },
      deleteSTORE: () => set({}, true),
      hydrateUSER: async () => {
        get()
          .fetchCOMPANY()
          .then((company) => {
            get().fetchOFFERINGS();
            if (company.users[get().USER.email]) {
              set({ USER: company.users[get().USER.email] });
            } else {
              get().clearUSER();
            }
          });
      },
    }),
    {
      name: "HSA-storage", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      onRehydrateStorage: (state) => {
        console.log("hydration starts");
        console.log({ state });
        // optional
        return (state, error) => {
          if (error) {
            console.log("an error happened during hydration", error);
          } else {
            console.log("hydration finished", { state });
          }
        };
      },
    }
  )
);
export const useColdStore = create(
  persist(
    (set, get) => ({
      COLDSALES: [],
      getCOLDSALES: () => get().COLDSALES,
      addCOLDSALES: (sale) =>
        set({
          COLDSALES: [
            ...get().COLDSALES,
            {
              id: cryptoRandomString({
                length: 32,
                type: "base64",
              }),
              sale,
            },
          ],
        }),
      removeCOLDSALE: (id) =>
        set({ COLDSALES: get().COLDSALES.filter((s) => s.id !== id) }),
      deleteCOLDSTORE: () => set({}, true),
    }),
    {
      name: "CSA-storage", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      onRehydrateStorage: (state) => {
        console.log("hydration starts");
        console.log({ state });
        // optional
        return (state, error) => {
          if (error) {
            console.log("an error happened during hydration", error);
          } else {
            console.log("hydration finished", { state });
          }
        };
      },
    }
  )
);
